module.exports = __webpack_public_path__ + "img/ongle-mycotique.a9be1271.jpg";